export default __webpack_public_path__ + "static/media/l12.f16b96d9.jpg";